import { Button } from "@/ds/shadcn/components/ui/button";
import { AuthHeader } from "@/features/auth/components/AuthHeader";
import { AuthHeaderSubtitle } from "@/features/auth/components/AuthHeaderSubtitle";
import { AuthHeaderTitle } from "@/features/auth/components/AuthHeaderTitle";
import { useEffectOnFirstMount } from "@/lib/common/useEffectOnFirstMount";
import { useTitle } from "@/lib/common/useTitle";
import { useAuthState } from "@/lib/state";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export const PageMfaDisabled = () => {
	useTitle("MFA Disabled");

	const { dispatchAuthLoggedOut } = useAuthState();
	const navigate = useNavigate();

	useEffectOnFirstMount(() => {
		dispatchAuthLoggedOut();
	});

	const navigateLogin = useCallback(() => {
		navigate("/login");
	}, []);

	return (
		<>
			<AuthHeader>
				<AuthHeaderTitle>Multi-factor Authentication Disabled</AuthHeaderTitle>
				<AuthHeaderSubtitle>Please click the button below to login again.</AuthHeaderSubtitle>
			</AuthHeader>

			<div className="flex justify-center">
				<Button variant="outline" onClick={navigateLogin}>
					Login
				</Button>
			</div>
		</>
	);
};
